import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import * as Unicons from '@iconscout/react-unicons';
import * as menuActions from './../../actions/menu';
import { connect } from 'react-redux';

class PageHeader extends React.Component{
    openMenu = () => {
        this.props.openMenu();
    }

    render = () => {
        return(
            <Grid container className="bg-primary">
                <Grid item xs={2}>
                <Typography variant="h3" align="center" color="textPrimary">
                <Unicons.UilBars className="cursor-pointer" size="30" color="#fff" onClick={this.openMenu} />
                </Typography>
                </Grid>
                <Grid item xs={8}>
                    <span className="d-block page-header-title text-light">{this.props.title}</span>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="h3" align="center" color="textPrimary">
                    <Unicons.UilSync size="30" color="#1a237e"  />

                    </Typography>
                </Grid>
                
            </Grid>
        )
    }
}
const mapToStateProps = (state) => {
    return state;
}
export default connect(mapToStateProps,menuActions)(PageHeader)